/* Vale Landing kit — interacciones (resultados, videos, FAQ, contador, paquetes, carrito) — sin dependencias */
(function () {
  if (window.__vlKit) return;
  window.__vlKit = true;

  /* Botón flotante del carrito.
     En páginas sin header el tema no encuentra #cart-icon-bubble y, al actualizar el carrito,
     escribe el contador encima del carrito (lo borra y deja la página bloqueada).
     Este botón aporta ese elemento y además permite volver al carrito. */
  var CART_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
  function initCartFab() {
    if (document.getElementById('cart-icon-bubble')) return;
    var a = document.createElement('a');
    a.id = 'cart-icon-bubble'; a.href = (window.routes && window.routes.cart_url) || '/cart';
    a.className = 'vl-cart-fab'; a.setAttribute('data-cart-icon-type', 'cart');
    a.setAttribute('aria-label', 'Ver carrito'); a.setAttribute('role', 'button');
    a.innerHTML = '<span class="svg-wrapper"><span class="cart-icon-cart">' + CART_SVG + '</span></span>';
    document.body.appendChild(a);
    a.addEventListener('click', function (e) {
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') { e.preventDefault(); d.open(a); }
    });
    fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js').then(function (r) { return r.json(); }).then(function (c) {
      if (c && c.item_count > 0 && !a.querySelector('.cart-count-bubble')) {
        var b = document.createElement('div'); b.className = 'cart-count-bubble';
        b.innerHTML = '<span aria-hidden="true">' + c.item_count + '</span>';
        a.appendChild(b);
      }
    }).catch(function () {});
  }
  /* Si el tema dejó la página bloqueada sin carrito visible, la desbloquea */
  function unlockIfStuck() {
    var d = document.querySelector('cart-drawer');
    if (document.body.classList.contains('overflow-hidden') && (!d || !d.classList.contains('active'))) {
      document.body.classList.remove('overflow-hidden');
    }
  }

  function bullets(holder, n, onClick) {
    if (!holder) return function () {};
    holder.innerHTML = '';
    holder.classList.add('vl-swiper-pagination-clickable', 'vl-swiper-pagination-bullets', 'vl-swiper-pagination-horizontal');
    var list = [];
    for (var i = 0; i < n; i++) {
      var b = document.createElement('span');
      b.className = 'vl-swiper-pagination-bullet'; b.setAttribute('role', 'button'); b.setAttribute('aria-label', 'Ir a ' + (i + 1));
      (function (k) { b.addEventListener('click', function () { onClick(k); }); })(i);
      holder.appendChild(b); list.push(b);
    }
    return function (k) { list.forEach(function (b, i) { b.classList.toggle('vl-swiper-pagination-bullet-active', i === k); }); };
  }

  function initResults(root) {
    root.querySelectorAll('[data-vl-results]').forEach(function (box) {
      if (box.__vl) return; box.__vl = true;
      var tabs = [].slice.call(box.querySelectorAll('.vl-sec1_thumbSwiper .vl-swiper-slide'));
      var slides = [].slice.call(box.querySelectorAll('.vl-sec1_mainSwiper .vl-swiper-slide'));
      var n = slides.length; if (!n) return;
      var cur = 0, setB = bullets(box.querySelector('.vl-s1-swiper-pagination'), n, go);
      function go(k) {
        cur = (k + n) % n;
        slides.forEach(function (s, i) { s.hidden = i !== cur; s.classList.toggle('vl-swiper-slide-active', i === cur); });
        tabs.forEach(function (t, i) { t.classList.toggle('vl-swiper-slide-thumb-active', i === cur); t.setAttribute('aria-pressed', String(i === cur)); });
        setB(cur);
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { go(i); });
        t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(i); } });
      });
      var nx = box.querySelector('.vl-swiper-button-next'), pv = box.querySelector('.vl-swiper-button-prev');
      if (nx) nx.addEventListener('click', function () { go(cur + 1); });
      if (pv) pv.addEventListener('click', function () { go(cur - 1); });
      go(0);
    });
  }

  function initVideos(root) {
    root.querySelectorAll('[data-vl-videos]').forEach(function (box) {
      if (box.__vl) return; box.__vl = true;
      var wrap = box.querySelector('.vl-swiper-wrapper');
      if (!wrap) return;
      var cards = [].slice.call(wrap.children), n = cards.length;
      function step() { return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : wrap.clientWidth; }
      function idx() { return Math.round(wrap.scrollLeft / (step() || 1)); }
      function to(k) { k = Math.max(0, Math.min(n - 1, k)); wrap.scrollTo({ left: k * step(), behavior: 'smooth' }); }
      var setB = bullets(box.querySelector('.vl-swiper-pagination'), n, to);
      var nx = box.querySelector('.vl-video_slide-button-next'), pv = box.querySelector('.vl-video_slide-button-prev');
      if (nx) nx.addEventListener('click', function () { to(idx() + 1 >= n ? 0 : idx() + 1); });
      if (pv) pv.addEventListener('click', function () { to(idx() - 1 < 0 ? n - 1 : idx() - 1); });
      var t; wrap.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { setB(Math.min(n - 1, idx())); }, 60); });
      setB(0);
    });
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function initTimers(root) {
    root.querySelectorAll('[data-vl-timer]').forEach(function (el) {
      if (el.__vlT) return; el.__vlT = true;
      var mins = parseInt(el.getAttribute('data-vl-timer'), 10) || 165;
      var key = 'vlTimerEnd:' + mins, end;
      try { end = parseInt(sessionStorage.getItem(key), 10); } catch (e) {}
      if (!end || end < Date.now()) { end = Date.now() + mins * 60000; try { sessionStorage.setItem(key, end); } catch (e) {} }
      function tick() {
        var left = Math.max(0, end - Date.now());
        if (!left) { end = Date.now() + mins * 60000; try { sessionStorage.setItem(key, end); } catch (e) {} }
        var s = Math.floor(left / 1000);
        el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
      }
      tick(); setInterval(tick, 1000);
    });
  }

  function initCounters(root) {
    var rows = root.querySelectorAll('[data-vl-counter]');
    if (!rows.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var row = en.target, end = parseInt(row.getAttribute('data-vl-counter'), 10) || 0;
        var num = row.querySelector('.vl-count'), bar = row.querySelector('.vl-result_bar_inr');
        if (bar) bar.style.width = end + '%';
        if (!num) return;
        var start = 10, t0 = null;
        function stepA(ts) { if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / 1200); num.textContent = Math.round(start + (end - start) * p); if (p < 1) requestAnimationFrame(stepA); }
        requestAnimationFrame(stepA);
      });
    }, { threshold: 0.3 });
    rows.forEach(function (r) { var bar = r.querySelector('.vl-result_bar_inr'); if (bar) bar.style.width = '0%'; io.observe(r); });
  }

  function init(root) { root = root || document; initResults(root); initVideos(root); initTimers(root); initCounters(root); }

  document.addEventListener('click', function (e) {
    var h = e.target.closest('.vl-page .vl-acdn-heading');
    if (h) {
      var c = h.nextElementSibling, open = h.classList.contains('vl-accordion-open');
      h.classList.toggle('vl-accordion-open', !open); h.classList.toggle('vl-accordion-close', open);
      h.setAttribute('aria-expanded', String(!open));
      if (c) { c.hidden = open; c.style.display = open ? 'none' : 'block'; }
      return;
    }
    var a = e.target.closest('.vl-page a[href^="#"]');
    if (a && !a.hasAttribute('data-vl-buy-submit') && !a.hasAttribute('data-vl-submit')) {
      var id = a.getAttribute('href').slice(1), target = id && document.getElementById(id);
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      return;
    }
    var v = e.target.closest('.vl-page [data-vdo]');
    if (v) {
      var src = v.getAttribute('data-vdo'); if (!src) return;
      var m = document.createElement('div'); m.className = 'vl-video-modal';
      m.innerHTML = '<button type="button" aria-label="Cerrar">&times;</button><video controls autoplay playsinline></video>';
      m.querySelector('video').src = src;
      m.addEventListener('click', function (ev) { if (ev.target === m || ev.target.tagName === 'BUTTON') m.remove(); });
      document.body.appendChild(m);
      return;
    }
    var more = e.target.closest('.vl-page .vl-testi-more');
    if (more) {
      var box = more.closest('.vl-testimonial-section'), hid = box && box.querySelector('.vl-testimonial-hide');
      if (hid) { hid.style.display = 'contents'; more.remove(); }
      return;
    }
    var card = e.target.closest('.vl-page .vl-package');
    if (card && !e.target.closest('button')) {
      card.parentElement.querySelectorAll('.vl-package').forEach(function (p) { p.classList.toggle('vl-active', p === card); });
    }
  });

  /* Cuando el carrito se abre tras agregar, quita el estado de carga de los botones */
  document.addEventListener('cart-drawer:update', function () {
    document.querySelectorAll('.vl-page .vl-loading').forEach(function (el) { el.classList.remove('vl-loading'); });
  });
  setInterval(unlockIfStuck, 1500);

  function boot() { initCartFab(); init(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();